



















































import Vue from 'vue';
import { mapActions } from 'vuex';

import FileUploadDropzone from '@reciprocity/file-dropzone';
import ZenButton from '@reciprocity/button';

import { BForm, BFormGroup, BFormInput, BProgress, VBTooltip } from 'bootstrap-vue';
import { SamlSettings } from '@/pages/settings/authentication/types';

import RemoveButton from './RemoveButton.vue';

export default Vue.extend({
  name: 'UploadMetadata',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    FileUploadDropzone,
    ZenButton,
    BProgress,
    RemoveButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    samlSettings: {
      type: Object as () => SamlSettings,
      default: {},
      required: true,
    },
  },
  data() {
    return {
      uploadProgress: <Number>0,
      filename: <string>'',
      url: <string>'',
      fileContent: <string>'',
    };
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    removeFile() {
      this.uploadProgress = 0;
      this.filename = '';
      this.fileContent = '';
    },
    loadMetadataFromFile() {
      this.$emit('update-saml-settings', {
        ...this.samlSettings,
        fileContent: this.fileContent,
        url: this.url,
      });
      this.removeFile();
      this.url = '';
    },
    async readFile(file: File) {
      this.uploadProgress = 10;
      this.filename = file.name;

      try {
        const reader = new FileReader();
        reader.onload = e => {
          this.fileContent = e.target.result;
        };
        reader.readAsText(file);
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: (error.response.data && error.response.data.message) || 'Something went wrong.',
        });
      } finally {
        this.uploadProgress = 100;
      }
    },
  },
});
